import clsx from 'clsx';
import React from 'react';

type EmptyStateProps = {
  children: React.ReactNode;
} & React.ComponentPropsWithoutRef<'div'>;

export function EmptyState({ children, className, ...props }: EmptyStateProps) {
  return (
    <div className={clsx(className, 'flex flex-col items-center')} {...props}>
      {children}
    </div>
  );
}

type EmptyStateImageProps = {
  src: string;
  alt: string;
};

export function EmptyStateImage({ src, alt }: EmptyStateImageProps) {
  return (
    <img src={src} className="my-5 h-39 w-39" alt={alt}/>
  );
}

type EmptyStateMessageProps = {
  children: React.ReactNode;
};

export function EmptyStateMessage({ children }: EmptyStateMessageProps) {
  return (
    <p className="pt-2.5 pb-6 text-base text-center">
      {children}
    </p>
  );
}

export function SleepyBulb() {
  return (
    <EmptyStateImage
      src="/img/empty_state_default.svg"
      alt="An illustration of a light bulb asleep, indicating that you don't have any accounts yet."
    />
  );
}

export function CreditCardsFannedOut() {
  return (
    <EmptyStateImage
      src="/img/empty_state_payment_methods.svg"
      alt="An illustration of a two credit cards fanned out."
    />
  );
}

export function NoAccountsYet() {
  return (
    <EmptyState>
      <SleepyBulb/>
      <EmptyStateMessage>
        No accounts have been linked yet.
      </EmptyStateMessage>
    </EmptyState>
  );
}
